const ProfileStatsField = ({ name, value, Icon, iconType }) => {
  return (
    <div className="flex flex-row items-center justify-between w-full px-3 py-4 rounded-lg bg-neutral-100">
      <div className="flex items-center justify-start space-x-4">
        {Icon && (
          <Icon
            className={`h-8 w-8 ${
              iconType === "google" && "fill-neutral-500"
            } ${iconType === "hero" && "text-neutral-500 stroke-2"}`}
          />
        )}
        <p className="text-2xl font-medium text-neutral-800">{name}</p>
      </div>
      <div className="flex items-center justify-end pl-10 Xbg-red-500">
        <p className="text-2xl font-medium text-neutral-800">{value}</p>
      </div>
    </div>
  );
};

const ValueField = ({ value }) => {
  return (
    <div
      className="flex flex-row items-center justify-center w-full h-11 px-3 py-2 rounded-lg Xbg-red-500
                   border border-1 border-neutral-300
                  "
    >
      <p className="text-base xl:text-xl font-normal">{value}</p>
    </div>
  );
};

const ZoomCoefficientValueField = ({ name, value }) => {
  return (
    <div className="flex flex-1 flex-row items-center justify-between w-full rounded-lg h-11 px-3 py-2 border border-1 border-neutral-300">
      <div className="flex items-center justify-start space-x-4">
        <p className="text-base xl:text-xl font-normal">{name}</p>
      </div>
      <div className="flex items-center justify-end pl-10 Xbg-red-500">
        <p className="text-base xl:text-xl font-normal">{value}</p>
      </div>
    </div>
  );
};

export { ProfileStatsField, ValueField, ZoomCoefficientValueField };
